import React from 'react';
import { Box, Text } from '@chakra-ui/react';

// Shared stat tile used by both the month summary (HabitCalendar) and the
// 365-day summary (ContributionHeatmap). Kept in one place so the two zoom
// levels of the same card never drift apart visually.
export function StatCard({ label, value, testId = 'stat-card' }) {
  return (
    <Box bg="gray.50" borderRadius="md" px={3} py={2} data-testid={testId} data-label={label}>
      <Text fontSize={{ base: 'sm', md: 'xl' }} fontWeight="semibold" lineHeight="1.2" whiteSpace="nowrap">
        {value}
      </Text>
      <Text fontSize="xs" color="gray.500" mt={1}>
        {label}
      </Text>
    </Box>
  );
}
